import { action } from 'satcheljs';
export default action('HIDE_QUICK_OPTIONS', function () { return ({}); });
//# sourceMappingURL=hideQuickOptions.js.map